export default __webpack_public_path__ + "static/media/api-logo.88234d15.png";